import React from "react";
import { MessageCircle } from "lucide-react";

const WhatsAppButton = () => {
  const phone = "919897388350";
  const message = "Hi LIS, I'd like to know more about your ISO consulting services.";
  const href = `https://wa.me/${phone}?text=${encodeURIComponent(message)}`;

  return (
    <a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Chat on WhatsApp"
      className="fixed bottom-6 right-6 z-[70] group"
    >
      <span className="absolute inset-0 rounded-full bg-emerald-500/40 animate-ping" style={{ animationDuration: "2.4s" }} />
      <span className="relative flex items-center gap-2 bg-emerald-500 hover:bg-emerald-600 text-white pl-3 pr-4 py-3 rounded-full shadow-xl transition-all duration-300">
        <MessageCircle size={22} />
        <span className="hidden sm:inline text-sm font-semibold whitespace-nowrap">Chat on WhatsApp</span>
      </span>
    </a>
  );
};

export default WhatsAppButton;
